<template>
    <flex-element :element-type="elementType" tag="li">
        <component
            :is="elements[0].elementType"
            v-if="elements[0]"
            v-bind="element(1)"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],

    props: {
        index: {
            type: Number,
            required: true,
        },
    },
};
</script>
